import { motion } from "framer-motion";
import { waLink } from "../lib/scroll";

const FLAVOURS = [
  "Mini Basque Cheesecakes — ₹100",
  "Chocochunk Cookie Pie — ₹180",
  "Double Chocochunk Cookie Pie — ₹200",
  "Hazelnut Cookie Pie — ₹220",
  "Pave Chocolates",
  "Olive & Sun-Dried Tomato Focaccia",
];

export default function WeekStrip() {
  return (
    <section id="week" className="scroll-mt-24 py-20 sm:py-28 border-y-[1.5px] border-line bg-sand/60">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-10">
        <div className="flex flex-col lg:flex-row lg:items-center gap-10 lg:gap-16">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.8 }}
            className="lg:w-[38%] shrink-0"
          >
            <p className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.3em] text-rust mb-4">
              This week
            </p>
            <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
              On the oven <span className="italic text-rust">this week.</span>
            </h2>
            <p className="mt-4 text-sm text-browntext leading-relaxed max-w-xs">
              Flavours change with the batch. Message us for today&apos;s
              lineup before it sells out.
            </p>
            <a
              href={waLink("Hi Zoni's Bakehouse! What's baking this week?")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="week-strip-ask-button"
              className="inline-flex items-center gap-2 mt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-ink border-b-2 border-rust pb-1.5 hover:text-rust transition-colors duration-300"
            >
              Ask what&apos;s baking today
            </a>
          </motion.div>

          <div className="flex flex-wrap gap-3 sm:gap-4 lg:justify-end" data-testid="week-strip-chips">
            {FLAVOURS.map((f, i) => (
              <motion.span
                key={f}
                data-testid={`week-strip-chip-${i + 1}`}
                initial={{ opacity: 0, y: 14, scale: 0.95 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                className="cursor-default bg-eggshell border-[1.5px] border-ink rounded-full px-5 py-2.5 font-display italic text-base sm:text-lg hover:bg-ink hover:text-eggshell transition-colors duration-300"
              >
                {f}
              </motion.span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
